import React from 'react';
import { styled } from 'styled-components';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';
import PlaylistFilter from './components/PlaylistFilter';
import PlaylistTable from './components/PlaylistTable';

const PlaylistManagementPage = () => {
  const modalConfirmRef = useModalConfirmRef();

  return (
    <Container>
      <PlaylistFilter />
      <PlaylistTable />
      <ModalConfirm ref={modalConfirmRef} />
    </Container>
  );
};

export default PlaylistManagementPage;

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .show-more-button {
    width: fit-content;
    margin: 0 auto;
  }
`;
